import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Anchor, Span } from '../styled/FieldStyles';

var CommentField = /*#__PURE__*/function (_Component) {
  _inherits(CommentField, _Component);

  var _super = _createSuper(CommentField);

  function CommentField() {
    _classCallCheck(this, CommentField);

    return _super.apply(this, arguments);
  }

  _createClass(CommentField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          hasAuthor = _this$props.hasAuthor,
          href = _this$props.href,
          onClick = _this$props.onClick,
          onFocus = _this$props.onFocus,
          onMouseOver = _this$props.onMouseOver;
      /* eslint-disable jsx-a11y/no-static-element-interactions */

      return href ? /*#__PURE__*/React.createElement(Anchor, {
        href: href,
        hasAuthor: hasAuthor,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver
      }, children) : /*#__PURE__*/React.createElement(Span, {
        hasAuthor: hasAuthor,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver
      }, children);
      /* eslint-enable jsx-a11y/no-static-element-interactions */
    }
  }]);

  return CommentField;
}(Component);

export { CommentField as default };